import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Table, TableAlign, TableVerticalAlign, Text, TextSize } from '@as/cotopaxi';
export const ProductSustainabilityFeatures = ({ features, contentSpacing, }) => {
    const defaultTableContentSpacing = {
        mobile: {
            spacing: {
                paddingTop: 1.5,
                paddingBottom: 1.5,
                paddingLeft: 2,
                paddingRight: 2,
            },
        },
    };
    return (_jsx(Box, { mobile: {
            spacing: { marginTop: 2.5 },
        }, tablet: {
            spacing: { marginTop: 2.5 },
        }, children: _jsx(Table, { striped: true, wrapText: true, align: TableAlign.LEFT, valign: TableVerticalAlign.TOP, children: _jsx(Table.Body, { children: features.map(feature => (_jsxs(Table.Row, { children: [_jsx("td", { style: { width: '40%' }, colSpan: feature.featureType === 'BOOLEAN' ? 2 : undefined, children: _jsx(Box, Object.assign({}, defaultTableContentSpacing, ((contentSpacing === null || contentSpacing === void 0 ? void 0 : contentSpacing.firstColumn) ? contentSpacing.firstColumn : {}), { children: _jsx(Text, { inline: true, size: TextSize.SMALL, withGlossary: true, children: feature.featureName }) })) }), feature.featureType !== 'BOOLEAN' && (_jsx(Table.Cell, { children: _jsx(Box, Object.assign({}, defaultTableContentSpacing, ((contentSpacing === null || contentSpacing === void 0 ? void 0 : contentSpacing.secondColumn) ? contentSpacing.secondColumn : {}), { children: _jsx(Text, { inline: true, size: TextSize.SMALL, withGlossary: true, children: feature.featureValue }) })) }))] }, feature.featureId))) }) }) }));
};
